import { render } from "./SideBySideImageGalleries.vue?vue&type=template&id=58500522"
import script from "./SideBySideImageGalleries.vue?vue&type=script&lang=js"
export * from "./SideBySideImageGalleries.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__